import { useState } from 'react';
import { Modal, Button, Input, Select, InputNumber, message, Form } from 'antd';
import baseuri from '../../methods/baseuri';

const { Option } = Select;

const ManualWebhookMakerModal = () => {
	const [visible, setVisible] = useState(false);
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();

	const handleSubmit = async (values: any) => {
		try {
			setLoading(true);
			const res = await baseuri.post('/admin/payment-gateways/manual-incredit-callback', values);
			message.success(res?.data?.message || 'Webhook triggered successfully!');
			setVisible(false);
			form.resetFields();
		} catch (e: any) {
			message.error(e?.response?.data?.message || 'An error occurred while triggering the webhook');
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Button
				type="primary"
				onClick={() => setVisible(true)}
				style={{ marginTop: '10px', marginBottom: '20px' }}
			>
				Manual Webhook Maker
			</Button>

			<Modal
				visible={visible}
				title="Manual Webhook Maker"
				onCancel={() => setVisible(false)}
				footer={[
					<Button key="back" onClick={() => setVisible(false)}>
						Cancel
					</Button>,
					<Button
						key="submit"
						type="primary"
						loading={loading}
						onClick={() => form.submit()}
					>
						Submit
					</Button>,
				]}
			>
				<Form
					form={form}
					layout="vertical"
					onFinish={handleSubmit}
					initialValues={{
						providerKey: 'SAFE_HAVEN',
					}}
				>
					<Form.Item
						label="Provider Key"
						name="providerKey"
						rules={[{ required: true, message: 'Please select a provider key' }]}
					>
						<Select>
							<Option value="SAFE_HAVEN">SAFE_HAVEN</Option>
							<Option value="PALMPAY">PALMPAY</Option>
							<Option value="BELLBANK">BELLBANK</Option>
						</Select>
					</Form.Item>

					<Form.Item
						label="Session ID"
						name="sessionId"
						rules={[{ required: true, message: 'Please enter a session ID' }]}
					>
						<Input placeholder="Unique session/transaction ID from the provider" />
					</Form.Item>

					<Form.Item
						label="Amount"
						name="amount"
						rules={[{ required: true, message: 'Please enter an amount' }]}
					>
						<InputNumber
							style={{ width: '100%' }}
							placeholder="Transaction amount (e.g., 5000)"
						/>
					</Form.Item>

					<Form.Item
						label="Source Account Name"
						name="sourceAccountName"
						rules={[{ required: true, message: 'Please enter source account name' }]}
					>
						<Input placeholder="Sender's name" />
					</Form.Item>

					<Form.Item
						label="Source Account Number"
						name="sourceAccountNumber"
						rules={[{ required: true, message: 'Please enter source account number' }]}
					>
						<Input placeholder="Sender's account number" />
					</Form.Item>

					<Form.Item
						label="Source Bank Name"
						name="sourceBankName"
						rules={[{ required: true, message: 'Please enter source bank name' }]}
					>
						<Input placeholder="Sender's bank name" />
					</Form.Item>

					<Form.Item
						label="Credit Account Number"
						name="creditAccountNumber"
						rules={[{ required: true, message: 'Please enter credit account number' }]}
					>
						<Input placeholder="Virtual account that received funds" />
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
};

export default ManualWebhookMakerModal;
